import {attended} from 'constants/url';
import {AddWith2ParamsOptions} from '../../../components/grid-dx/types';
import authFetch from '../../../helpers/requests';
import {useSelector} from 'react-redux';

function useAddCollaboratorInAttended() {
  const addCollaboratorInAttended = useAddWith2ParamsOptions(attended);
  return (addWith2ParamsOptions: AddWith2ParamsOptions) =>
    addCollaboratorInAttended(addWith2ParamsOptions);
}

function useAddWith2ParamsOptions(url: string) {
  const token: string = useSelector(
    (state: any) => state.authentication.user.token,
  );
  return async (addWith2ParamsOptions: AddWith2ParamsOptions) => {
    let options = new URLSearchParams();
    let json = {
      collaborators: addWith2ParamsOptions.AddedOne,
      pass: addWith2ParamsOptions.AddedThree.pass,
      reason: addWith2ParamsOptions.AddedThree.reason,
      user: addWith2ParamsOptions.AddedThree.user,
      id_course: addWith2ParamsOptions.AddedTwo.id_course,
      id_instance: addWith2ParamsOptions.AddedTwo.id_instance,
    };
    try {
      const response = await authFetch(
        `${url}?${options}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify(JSON.stringify(json)),
        },
        token,
      );
      return response;
    } catch (e) {
      return {};
    }
  };
}

export default useAddCollaboratorInAttended;
